export default __webpack_public_path__ + "static/media/domaci-limolada.8d7b2ef2.jpg";